import { Stack } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { FirstSegment } from './FirstSegment';
import { SecondeSegment } from './SecondeSegment';
import { Title } from './Title';
import { FourSegment } from './FourSegment';
import { ContactUsSegment } from './ContactUsSegment';

export const EquipmentNotAllowed = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  return (
    <Stack
      tabIndex={0}
      rowGap='40px'
      p={isDesktop ? '11px 0 0' : '48px 0 120px'}
    >
      <Title />
      <FirstSegment />
      <SecondeSegment />

      <FourSegment
        steps={[
          dictionary.aDistrictDoctorWillExamineYourApplicationAndForwardARecommendationToTheDepartment,
          dictionary.weWillCreateAnEligibilityCardForYouWhichWillIncludeTheItemsApprovedForYou,
          dictionary.asSoonAsTheReferralIsReceivedBySuperPharmWeWillSendYouATextMessage,
          dictionary.superfarmWillDeliverToYourHome,
        ]}
      />

      <ContactUsSegment />
    </Stack>
  );
};
